import { PlanarSet, Box } from '@flatten-js/core';

/**
 * @typedef {{
 *  box : Box
 * }} HasBox
 */

export default class EnhancedPlanarSet extends PlanarSet {
  constructor(shapes) {
    super(shapes);
    this.calculateCenter();
  }

  /**
   * 
   * @param {HasBox} shape 
   */
  add(shape) {
    super.add(shape);
    const xMin = Math.min(this.box.xmin, shape.box.xmin);
    const xMax = Math.max(this.box.xmax, shape.box.xmax);
    const yMin = Math.min(this.box.ymin, shape.box.ymin);
    const yMax = Math.max(this.box.ymax, shape.box.ymax);
    if (xMin !== this.box.xmin || xMax !== this.box.xmax || yMin !== this.box.ymin || yMax !== this.box.ymax) {
      this.box = new Box(xMin, yMin, xMax, yMax);
    }
  }

  /**
   * 
   * @param {HasBox} shape 
   */
  delete(shape) {
    super.delete(shape);
    if (shape.box.xmin === this.box.xmin || shape.box.xmax === this.box.xmax || shape.box.ymin === this.box.ymin || shape.box.ymax === this.box.ymax) {
      this.calculateCenter();
    }
  }
  calculateCenter() {
    let xMin = Infinity;
    let yMin = Infinity;
    let xMax = 0;
    let yMax = 0;

    // eslint-disable-next-line no-restricted-syntax
    for (const entry of this.values()) {
      xMin = Math.min(xMin, entry.box.xmin);
      xMax = Math.max(xMax, entry.box.xmax);
      yMin = Math.min(yMin, entry.box.ymin);
      yMax = Math.max(yMax, entry.box.ymax);
    }
    this.box = new Box(xMin, yMin, xMax, yMax);
  }
}